import {get} from 'lodash'
import {ready} from './addiesaas'
import $ from 'jquery'
import ls from './storage'

const store = 'Shop/Orders' // items
const storage = 'Shop/Orders.Cart.items' // items

export const getCartCount = () => {
  const cartItems = Object.values(get(ls(store) || {}, storage, {}))
  return cartItems.filter((i) => !(i && i.attributes && i.attributes.skipCartCount)).length
}
export const update = (dom) => {
  const count = getCartCount()
  dom.find('.re-cart-count').html(count).attr('data-count', count)
  dom.find('.re-cart-count').hide()
  if (count > 0) {
    dom.find('.re-cart-count').show()
  }
}

export const cart = {
  getCartCount,
  update,
  init(urls) {
    const cartLink = urls.cart
    const count = getCartCount()
    const dom = $(`
      <div class="addiesaas-component">
        <div class="rocket-effect-container re-mini-component re-mini-cart">
          <a href="${cartLink}" class="re-cart-icon">
            <span class="re-cart-count" data-count="${count}">${count}</span>
          </a>
        </div>
      </div>
    `)

    ready(() => {
      const EventBus = window.VueEventBus
      if (EventBus) {
        EventBus.$on('cart.item.added', function () {
          update(dom)
        });
        EventBus.$on('cart.item.updated', function () {
          update(dom)
        });
        EventBus.$on('cart.item.removed', function () {
          update(dom)
        });
        EventBus.$on('cart.cleared', function () {
          update(dom)
        });
      }
    })

    return dom
  }
}
export default cart
